import { gql } from "graphql-tag";

export const findBookMatchScoreForUser = gql`
  query FindBookMatchScoreForUser($userId: bigint!, $bookId: bigint!) {
    recommendations(
      where: {
        subject_type: { _eq: "User" }
        subject_id: { _eq: $userId }
        item_type: { _eq: "Book" }
        item_id: { _eq: $bookId }
      }
      limit: 10
    ) {
      ...MatchPercentageFragment
    }
  }
`;
